import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import logo from "./img/arkodomo-logo-white-no-background.png";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import React from "react";
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

type Props = {
    onOpenWaitlist?: (reason?: 'request-access' | 'design-partner') => void;
}

function MainNavBar({ onOpenWaitlist }: Props) {
    return (
        <Navbar expand="lg" className="bg-body-tertiary navbar-border" fixed="top" bg="dark" data-bs-theme="dark">
            <Container>
                <Navbar.Brand as={Link} to="/"><img src={logo} alt={"Arkodomo"} width="110px"/> </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={Link} to="/">Product</Nav.Link>
                        <Nav.Link href="/#how-it-works">How it Works</Nav.Link>
                        <Nav.Link href="/#security">Security</Nav.Link>
                        <Nav.Link href="/#faq">FAQ</Nav.Link>
                        <Nav.Link as={Link} to="/pricing">Pricing</Nav.Link>
                        <NavDropdown title="Company" id="company-nav-dropdown" menuVariant="dark">
                            <NavDropdown.Item as={Link} to="/about">About</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/contact">Contact</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                    <div className="d-flex">
                        <Button variant="primary" onClick={() => onOpenWaitlist && onOpenWaitlist('request-access')}>Join Waitlist</Button>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MainNavBar;
